import React, { useEffect, useState } from 'react';
import { Button, MenuItem, Select, Popover } from '@material-ui/core';
import { FormControl } from '@mui/material';
import { addDays } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import {
  // ANALYTIC_CHECK_IN_CHANNELS_DROPDOWN,
  ANALYTIC_USAGE_DROPDOWN,
} from '../../constants/AnalyticsConst';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';
import './analytics.scss';
import Reservations from './reservations/Reservations';
import Spa from './Spa/Spa';
import {
  selectedHotelSelector,
  allRestaurantSelector,
  allSpaInfoSelector,
  selectedBrandSelector,
  selectedGroupSelector,
  filteredHotelsSelector,
  filteredBrandsSelector,
  fetchAllRestaurant,
  fetchAllSpa,
} from '../../layouts/property/propertySlice';
import Housekeeping from './housekeeping/Housekeeping';
import Ird from './ird/Ird';
import DigitalCheckIn from './digital-check-in/Digital-Check-In';
import AppUsage from './app-usage/App-Usage';
import LinearProgressBar from '../../shared/progress-bar/Progress';
import { RBAC_PERMISSION_LEVEL_NO_ACCESS } from '../../constants/RoleConsts';
import { appUsageSelector } from './AnalyticsSlice';
import { isEmpty } from 'lodash';
import { getAnalyticsModulePermissionList } from '../../utils/analyticsAPIUtils';
import { makeStyles } from '@material-ui/core/styles';
import { notificationManager } from '../../utils/NotificationUtils';
import { today } from '../../utils/commonUtils';

export const statisticsDataKeys = {
  date: 'Date',
  itemName: 'itemName',
  name: 'Name',
  errorDate: 'Error Date',
  reservationId: 'Reservation Id',
  errorMessage: 'Error Message',
  error: 'Error',
  errors: 'Errors',
  checkIn: 'Check-In',
  checkInOut: 'Check-Out',
  currencyCode: 'Currency Code',
  errorCount: 'Error Count',
  dateFormat: 'DD MMM YYYY',
  dateFormatISO: 'YYYY-MM-DD',
  errorReportDateFormat: 'DD/MM/YYYY',
  dateMonthFormat: 'DD MMM',
  monthFormat: 'MMM',
  treatmentCount: 'Treatment Count',
  treatmentAmount: 'Treatment Amount',
  preCheckInCount: 'Pre-Check-In Count',
  checkInCount: 'Check-In Count',
  count: 'Count',
  orderAmount: 'Order Amount',
  orderCount: 'Order Count',
  requestCount: 'Request Count',
  requestAmount: 'Request Amount',
  busiestTimeOfTheDay: 'Busiest Time Of Day',
  busiestDayOfTheWeek: 'Busiest Day Of Week',
  avgItemsOnOrder: 'Avg Items On Order',
  avgOrderItemsCount: 'Avg Order Items Count',
  avgRequestItemsCount: 'Avg Request Items Count',
  avgItemsPerOrder: 'Avg Items Per Order',
  medianItemsPerOrder: 'Median Items Per Order',
  averageItemsPerRequest: 'Avg Items Per Request',
  medianItemsPerRequest: 'Median Items Per Request',
  avgTreatmentPerAppointment: 'Avg Treatment Per Appointment',
  medianTreatmentPerAppointment: 'Median Treatment Per Appointment',
  daysSinceLastOrdered: 'Days Since Last Ordered',
  daysSinceLastTreatment: 'Days Since Last Treatment',
  revenue: 'Revenue',
  reservationCount: 'Reservation Count',
  bookingCount: 'Booking Count',
};

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    minWidth: '170px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    minWidth: '170px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Analytics = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const classes = useStyles();

  const selectedHotel = useSelector(selectedHotelSelector);
  const selectedBrand = useSelector(selectedBrandSelector);
  const selectedGroup = useSelector(selectedGroupSelector);

  const originalRestList = useSelector(allRestaurantSelector);
  const spaList = useSelector(allSpaInfoSelector);
  const activeBrand = useSelector(selectedBrandSelector);
  const selectedHotelList = useSelector(filteredHotelsSelector);
  const selectedBrandList = useSelector(filteredBrandsSelector);

  const [showAllForReport, setShowAllForReport] = useState(false);
  const [currentModule, setCurrentModule] = useState('checkIn');
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentRestaurant, setCurrentRestaurant] = useState('placeholder');
  const [currentSpa, setCurrentSpa] = useState('allSpa');
  const [currentChannel, setCurrentChannel] = useState('all');
  const [loading, setLoading] = useState(false);
  const [reportModules, setReportModules] = useState([]);
  const appUsageData = useSelector(appUsageSelector);
  const [brandName, setBrandName] = useState({});
  const [hotelName, setHotelName] = useState({});
  const [activeTab, setActiveTab] = useState('hotel');
  const [range, setRange] = useState([
    {
      startDate: addDays(new Date(), -30),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [dates, setDates] = useState({
    start: addDays(new Date(), -30),
    end: new Date(),
  });

  const open = Boolean(anchorEl);
  const [openAllModulesSelect, setOpenAllModulesSelect] = useState(false);
  const [openRestaurantSelect, setOpenRestaurantSelect] = useState(false);
  const [openSpaSelect, setOpenSpaSelect] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedBrand && selectedHotel && selectedGroup) {
      handleGetPermission();
    }
  }, [permissions, selectedBrand, selectedGroup, selectedHotel]);

  const handleGetPermission = async () => {
    let analyticModuleList = [...ANALYTIC_USAGE_DROPDOWN];

    try {
      let res = await getAnalyticsModulePermissionList({
        hotelId: selectedHotel,
        groupId: selectedGroup,
        brandId: selectedBrand,
      });

      if (res?.data?.getEnabledAnalyticsModules?.modules?.length) {
        analyticModuleList = analyticModuleList?.filter((item) =>
          res?.data?.getEnabledAnalyticsModules?.modules?.includes(item?.value),
        );

        setCurrentModule(analyticModuleList[0]?.value);
        setReportModules(analyticModuleList);
      } else {
        if (permissions?.appUsageReport === RBAC_PERMISSION_LEVEL_NO_ACCESS) {
          analyticModuleList = analyticModuleList?.filter((item) => item?.value !== 'appUsage');
        }
        if (permissions?.restaurantReport === RBAC_PERMISSION_LEVEL_NO_ACCESS) {
          analyticModuleList = analyticModuleList?.filter((item) => item?.value !== 'restaurant');
        }
        if (permissions?.inRoomDiningReport === RBAC_PERMISSION_LEVEL_NO_ACCESS) {
          analyticModuleList = analyticModuleList?.filter((item) => item?.value !== 'ird');
        }
        if (permissions?.houseKeepingReport === RBAC_PERMISSION_LEVEL_NO_ACCESS) {
          analyticModuleList = analyticModuleList?.filter((item) => item?.value !== 'hk');
        }
        if (permissions?.spaReport === RBAC_PERMISSION_LEVEL_NO_ACCESS) {
          analyticModuleList = analyticModuleList?.filter((item) => item?.value !== 'spa');
        }
        if (permissions?.digitalCheckInReport === RBAC_PERMISSION_LEVEL_NO_ACCESS) {
          analyticModuleList = analyticModuleList?.filter((item) => item?.value !== 'checkIn');
        }

        if (analyticModuleList?.length > 0) {
          let checkIn = analyticModuleList?.find((element) => element?.value === 'checkIn');

          if (checkIn) {
            setCurrentModule(checkIn?.value);
          } else {
            setCurrentModule(analyticModuleList[0]?.value);
          }
        }

        setReportModules(analyticModuleList);
      }
    } catch (err) {
      notificationManager('danger', 'Error while fetching analytics module permissions');
    }
  };

  useEffect(() => {
    if (selectedHotel) {
      setLoading(true);
      const timeoutId = setTimeout(() => {
        setCurrentRestaurant('placeholder');
        setCurrentSpa('allSpa');
        setLoading(false);
      }, 1000);

      return () => clearTimeout(timeoutId);
    } else {
      setLoading(true);
    }
  }, [selectedHotel]);

  useEffect(() => {
    setLoading(isEmpty(appUsageData));
  }, [appUsageData]);

  useEffect(() => {
    let hotelData = selectedHotelList?.find((hotel) => hotel?.id === selectedHotel);
    let brandData = selectedBrandList?.find((brand) => brand?.id === activeBrand);
    setBrandName(brandData);
    setHotelName(hotelData);
  }, [activeBrand, selectedHotel]);

  const handleModuleChange = (e) => {
    const selectedModule = e?.target?.value;
    setCurrentModule(selectedModule);
    if (selectedModule === 'restaurant' && selectedHotel) {
      dispatch(fetchAllRestaurant(selectedHotel));
    }
    if (selectedModule === 'spa' && selectedHotel) {
      dispatch(fetchAllSpa(selectedHotel));
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    const st = new Date(range[0]?.startDate);
    const et = new Date(range[0]?.endDate);
    const correctedEndDate = et > today ? today : et;

    setDates({
      start: st,
      end: correctedEndDate,
    });
    setAnchorEl(null);
  };

  const onCancelOverlay = () => {
    const correctedEndDate = dates?.end > today ? today : dates?.end;

    setRange([
      {
        startDate: dates?.start,
        endDate: correctedEndDate,
        key: 'selection',
      },
    ]);
    setAnchorEl(null);
  };

  const onRestaurantChange = (e) => {
    setCurrentRestaurant(e.target.value);
  };

  const onSpaChange = (e) => {
    setCurrentSpa(e.target.value);
  };

  //temporarily disable
  // const onChannelChange = (e) => {
  //   setCurrentChannel(e.target.value);
  // };

  return (
    <div>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : (
        <div className='container mt-4 mw-100'>
          <div className='row d-flex'>
            <div className='col-md-6 d-flex align-items-center'>
              <div className='page-title'>Analytics</div>
              <div className='analytics-bete'>Beta</div>
            </div>
          </div>
          <div className='d-flex pt-3 flex-wrap justify-content-between align-items-center gap-2 col-md-12'>
            <div className='col p-0 gap-3 d-flex'>
              <div>
                <Button
                  size='large'
                  variant={'outlined'}
                  className={activeTab === 'brand' ? classes.activeButton : classes.button}
                  onClick={() => {
                    setActiveTab('brand');
                  }}
                >
                  {brandName?.name}
                </Button>
              </div>
              <div>
                <Button
                  size='large'
                  variant={'outlined'}
                  className={activeTab === 'hotel' ? classes.activeButton : classes.button}
                  onClick={() => {
                    setActiveTab('hotel');
                  }}
                >
                  {hotelName?.name}
                </Button>
              </div>
              <div>
                {activeTab === 'hotel' && (
                  <div className='d-flex flex-wrap flex-lg-nowrap gap-3'>
                    <Button
                      className='py-2 dropdown-button'
                      variant='outlined'
                      color='secondary'
                      size='medium'
                      onClick={() => {
                        setOpenAllModulesSelect(!openAllModulesSelect);
                      }}
                    >
                      <FormControl variant='standard' sx={{ minWidth: 100 }}>
                        <Select
                          open={openAllModulesSelect}
                          labelId='restlist-label'
                          id='rest-select-standard'
                          value={currentModule}
                          onChange={(e) => handleModuleChange(e)}
                          label=''
                          className='dashboard-restaurant-list-dropdown '
                          MenuProps={{
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            getContentAnchorEl: null,
                          }}
                        >
                          {reportModules?.map((rest) => (
                            <MenuItem
                              key={rest?.value}
                              value={rest?.value}
                              className='analytic-dropdown-list'
                            >
                              {rest?.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Button>
                    {currentModule === 'restaurant' && (
                      <Button
                        className='py-2 dropdown-button'
                        variant='outlined'
                        color='secondary'
                        size='medium'
                        onClick={() => {
                          setOpenRestaurantSelect(!openRestaurantSelect);
                        }}
                      >
                        <FormControl variant='standard' sx={{ mx: 1, minWidth: 100 }}>
                          <Select
                            open={openRestaurantSelect}
                            labelId='restlist-label'
                            id='rest-select-standard'
                            value={currentRestaurant}
                            onChange={(e) => onRestaurantChange(e)}
                            label='All Restaurant'
                            className='dashboard-restaurant-list-dropdown'
                          >
                            <MenuItem value={'placeholder'} className='analytic-dropdown-list'>
                              All Restaurant
                            </MenuItem>
                            {originalRestList?.map((rest) => (
                              <MenuItem
                                key={rest?.id}
                                value={rest?.id}
                                className='analytic-dropdown-list'
                              >
                                {rest?.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Button>
                    )}
                    {currentModule === 'spa' && (
                      <Button
                        className='py-2 dropdown-button'
                        variant='outlined'
                        color='secondary'
                        size='medium'
                        onClick={() => {
                          setOpenSpaSelect(!openSpaSelect);
                        }}
                      >
                        <FormControl variant='standard' sx={{ mx: 1, minWidth: 100 }}>
                          <Select
                            open={openSpaSelect}
                            labelId='restlist-label'
                            id='rest-select-standard'
                            value={currentSpa}
                            onChange={(e) => onSpaChange(e)}
                            label='All Spa'
                            className='dashboard-restaurant-list-dropdown'
                          >
                            <MenuItem value={'allSpa'} className='analytic-dropdown-list'>
                              All Spa
                            </MenuItem>
                            {spaList?.map((rest) => (
                              <MenuItem
                                key={rest?.id}
                                value={rest?.id}
                                className='analytic-dropdown-list'
                              >
                                {rest?.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className='col d-flex justify-content-end'>
              <div className='ps-2 '>
                <div className='ps-2 '>
                  <Button
                    className={
                      !open ? 'custom-date-range-picker' : 'custom-date-range-picker-clicked'
                    }
                    variant='outlined'
                    color='secondary'
                    size='large'
                    startIcon={
                      <img
                        className='mb-1 ms-2'
                        src={'./assets/icons/dashboard/date-range.svg'}
                        alt={'completed'}
                      />
                    }
                    onClick={handleClick}
                  >
                    {`${moment(dates?.start).format('DD/MM/YYYY')} - ${moment(dates?.end).format(
                      'DD/MM/YYYY',
                    )}`}
                  </Button>

                  <Popover
                    id={'simple-popover'}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={onCancelOverlay}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    className='pointer custom-pop-over'
                  >
                    <div className='custom-btn-wrapper d-flex'>
                      <Button
                        variant='outlined'
                        color='secondary'
                        size='medium'
                        onClick={onCancelOverlay}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant='contained'
                        color='Primary'
                        size='medium'
                        className='cancel-btn'
                        onClick={handleClose}
                      >
                        Apply
                      </Button>
                    </div>
                    <DateRangePicker
                      onChange={(item) => setRange([item?.selection])}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      months={2}
                      ranges={range}
                      direction='horizontal'
                      maxDate={new Date()}
                      rangeColors={['#29E67C']}
                    />
                  </Popover>
                </div>
              </div>
            </div>
          </div>
          {activeTab === 'brand' && (
            <>
              <AppUsage
                startDate={moment(dates?.start).format(statisticsDataKeys.dateFormatISO)}
                endDate={moment(dates?.end).format(statisticsDataKeys.dateFormatISO)}
                hotelId={selectedHotel}
              />
            </>
          )}

          {activeTab === 'hotel' && (
            <>
              <div className='row d-flex mt-3'>
                {/* Temporarily hide the Channel-related concept.
                <div className="col-md-7 d-flex justify-content-end">
                  {currentModule === "checkIn" && (
                    <Button
                      className="me-4 py-2 dropdown-button"
                      variant="outlined"
                      color="secondary"
                      size="medium"
                    >
                      <FormControl
                        variant="standard"
                        sx={{ mx: 1, minWidth: 100 }}
                      >
                        <Select
                          labelId="restlist-label"
                          id="rest-select-standard"
                          value={currentChannel}
                          onChange={(e) => onChannelChange(e)}
                          label="All channels"
                          className="dashboard-restaurant-list-dropdown"
                        >
                          {ANALYTIC_CHECK_IN_CHANNELS_DROPDOWN?.map((rest) => (
                            <MenuItem
                              key={rest?.value}
                              value={rest?.value}
                              className="analytic-dropdown-list"
                            >
                              {rest?.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Button>
                  )}
                </div> */}
              </div>
              <div className='py-3'>
                {currentModule === 'restaurant' && (
                  <Reservations
                    startDate={moment(dates?.start).format(statisticsDataKeys.dateFormatISO)}
                    endDate={moment(dates?.end).format(statisticsDataKeys.dateFormatISO)}
                    hotelId={selectedHotel}
                    onsetPage={(e) => setPage(e)}
                    page={page}
                    onsetRowsPerPage={(e) => setRowsPerPage(e)}
                    rowsPerPage={rowsPerPage}
                    restaurantId={currentRestaurant !== 'placeholder' ? currentRestaurant : ''}
                    showLoader={showLoader}
                    showAllForReport={showAllForReport}
                    setShowAllForReport={setShowAllForReport}
                  />
                )}
                {currentModule === 'spa' && (
                  <Spa
                    startDate={moment(dates?.start).format(statisticsDataKeys.dateFormatISO)}
                    endDate={moment(dates?.end).format(statisticsDataKeys.dateFormatISO)}
                    hotelId={selectedHotel}
                    onsetPage={(e) => setPage(e)}
                    page={page}
                    onsetRowsPerPage={(e) => setRowsPerPage(e)}
                    rowsPerPage={rowsPerPage}
                    spaId={currentSpa !== 'allSpa' ? currentSpa : ''}
                    showLoader={showLoader}
                    showAllForReport={showAllForReport}
                    setShowAllForReport={setShowAllForReport}
                  />
                )}
                {currentModule === 'hk' && (
                  <Housekeeping
                    startDate={moment(dates?.start).format(statisticsDataKeys.dateFormatISO)}
                    endDate={moment(dates?.end).format(statisticsDataKeys.dateFormatISO)}
                    hotelId={selectedHotel}
                    showLoader={showLoader}
                    showAllForReport={showAllForReport}
                    setShowAllForReport={setShowAllForReport}
                  />
                )}
                {currentModule === 'ird' && (
                  <Ird
                    startDate={moment(dates?.start).format(statisticsDataKeys.dateFormatISO)}
                    endDate={moment(dates?.end).format(statisticsDataKeys.dateFormatISO)}
                    hotelId={selectedHotel}
                    showLoader={showLoader}
                    showAllForReport={showAllForReport}
                    setShowAllForReport={setShowAllForReport}
                  />
                )}

                {currentModule === 'checkIn' && (
                  <DigitalCheckIn
                    startDate={moment(dates?.start)?.format(statisticsDataKeys.dateFormatISO)}
                    endDate={moment(dates?.end)?.format(statisticsDataKeys.dateFormatISO)}
                    hotelId={selectedHotel}
                    showLoader={showLoader}
                    currentChannel={currentChannel !== 'all' ? currentChannel : ''}
                    showAllForReport={showAllForReport}
                    setShowAllForReport={setShowAllForReport}
                  />
                )}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Analytics;
